import { SxStyles } from '../../types';
import theme from '../../theme';
import { getResponsiveSize } from '../../utils';

export const ScoreContainerStyles: SxStyles = {
  scoreContainer: {
    paddingTop: getResponsiveSize(10),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: getResponsiveSize(10),
    '&.adding': {
      flexDirection: 'column',
      '& .score-title': {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: getResponsiveSize(10),
      },

      '& .score': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: getResponsiveSize(2),

        '& .score-count': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'white',
          border: '1px solid #666',
          cursor: 'pointer',
          width: getResponsiveSize(23),
          height: getResponsiveSize(23),
          // minWidth: '23px',
          // minHeight: '23px',
          borderRadius: '50%',

          '&.selected': {
            '& .score-value': {
              color: 'white',
            },
          },

          '&:hover, &:focus': {
            backgroundColor: '#2491ba',
            opacity: 0.7,
          },

          '& .score-value': {
            fontWeight: 'bold',
            fontSize: '13px',
            color: '#666',
            lineHeight: '1',
            ['@media screen and (max-width: 1441px)']: {
              fontSize: '11px',
            },
            ['@media screen and (min-width: 3840px)']: {
              fontSize: '21px',
            },
          },
        },
      },

      '& .controls': {
        marginTop: getResponsiveSize(20),
        display: 'flex',
        alignItems: 'center',

        '& button': {
          padding: `${getResponsiveSize(8)} ${getResponsiveSize(16)}`,
          cursor: 'pointer',
          borderRadius: '6px',
          borderColor: 'transparent',

          '&:hover': {
            opacity: 0.9,
          },
        },

        '& .save': {
          backgroundColor: '#517ec5',
          color: 'white',
        },

        '& .cancel': {
          marginLeft: getResponsiveSize(20),
          color: '#454545',
          backgroundColor: 'white',
        },
        '& .show-info': {
          marginLeft: getResponsiveSize(20),
          color: '#454545',
          backgroundColor: 'white',
        },
        '& .info-disabled': {
          marginLeft: getResponsiveSize(20),
          opacity: 0.5,
          backgroundColor: 'white',

          '&:hover': {
            opacity: 0.5,
          },
        },
      },
    },

    '& .score-title': {
      mx: getResponsiveSize(24),
      fontWeight: 'bold',

      '& .text': {
        fontSize: theme.typography.fs12,
      },
    },

    '& .score': {
      display: 'flex',
      flexWrap: 'wrap',
      gap: getResponsiveSize(2),

      '& .score-count': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: getResponsiveSize(23),
        height: getResponsiveSize(23),
        // minWidth: '23px',
        // minHeight: '23px',
        borderRadius: '50%',
        border: '1px solid #666',

        '& .score-value': {
          fontWeight: 'bold',
          fontSize: '13px',
          color: '#666',
          lineHeight: '1',
          ['@media screen and (max-width: 1441px)']: {
            fontSize: '11px',
          },
          ['@media screen and (min-width: 3840px)']: {
            fontSize: '21px',
          },
        },

        '&.to-delete': {
          backgroundColor: '#be1440',
          color: 'white',
          cursor: 'pointer',
        },

        '&.add': {
          fontSize: theme.typography.fs19,
          lineHeight: '1.5em',
          backgroundColor: '#5d5d5d',
          cursor: 'pointer',
          color: 'white',
          border: 'none',
        },
      },
    },
  },
};
